import { EnrollmentAdditionalCriteriaField } from 'types';

export const enrollmentAdditionalCriteriaFields: Record<
    EnrollmentAdditionalCriteriaField,
    EnrollmentAdditionalCriteriaField
> = {
    multipleChildrenFamily: 'multipleChildrenFamily',
    bothParentsDisability: 'bothParentsDisability',
    oneParentDisability: 'oneParentDisability',
    childDisability: 'childDisability',
    fosterCare: 'fosterCare',
    siblingDisability: 'siblingDisability',
    singleParenting: 'singleParenting',
};

export const enrollmentAdditionalCriteriaFieldsArray = Object.values(
    enrollmentAdditionalCriteriaFields,
);
